import includes from 'ramda/src/includes';

export const isIncludeCardinal = includes("cardinal");
